<app-ui-sms-list
    (onCreate)="newSMS()"
    (onSort)="onSort($event)"
    (onSetPage)="setPage($event.offset)"
    (onPageLimit)="pageLimit($event)"
    [rows]="rows"
    [isLoading]="isLoading"
    [page]="page"
    [showCreate]="showCreate">
</app-ui-sms-list>
